<template>
  <v-container class="register-page fill-height">
    <v-row align="center" justify="center" class="fill-height ma-0">
      <transition mode="out-in">
        <v-col cols="12" sm="9" md="7" lg="6" xl="4" style="min-width: 300px;" v-if="!showForgotPasswordAnswer" key="request">
          <v-card class="pa-8">
            <v-row align="center" justify="center">
              <v-col cols="auto">
                <Logo class="if-logo" />
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="mb-6">
              <v-col cols="auto">
                <div class="text-uppercase text-center mb-2">Forgot your password?</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="text-center">Enter the email that you used to register, we will send you a code to reset your password</p>
                <v-form ref="requestForm" v-model="requestValid" action="javascript:void(0);" >
                  <v-text-field outlined v-model="email" :rules="$root.auth.emailRules" required label="E-Mail" />
                  <v-btn block depressed rounded light large :loading="$root.auth.working" type="submit" @click="sendRequest">Send code</v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" sm="9" md="7" lg="6" xl="4" style="min-width: 300px;" v-else key="answer">
          <v-card class="pa-8">
            <v-row align="center" justify="center">
              <v-col cols="auto">
                <Logo class="if-logo" />
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="mb-6">
              <v-col cols="auto">
                <div class="text-uppercase text-center mb-2">Forgot your password?</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="text-center">Enter the code you received by email and your new password</p>
                <v-form ref="answerForm" v-model="answerValid" action="javascript:void(0);" >
                  <v-text-field outlined v-model="code" :rules="$root.auth.codeRules" required label="Reset Code" />
                  <v-text-field outlined type="password" v-model="newPassword" :rules="$root.auth.passwordRules" required label="New Password" />
                  <v-text-field outlined type="password" v-model="repeatNewPassword" :rules="repeatPasswordRules" required label="Repeat New Password" />
                  <template v-if="serverError">
                    <b class="d-block text-center yellow--text">{{this.serverError}}</b>
                    <v-col cols="12" class="text-center">Code not received? <v-btn text depressed tile class="text-decoration-underline mb-4" :loading="$root.auth.working" @click="showForgotPasswordAnswer = false">Send code again</v-btn></v-col>
                  </template>
                  <v-btn block depressed rounded light large :loading="$root.auth.working" type="submit" @click="sendAnswer">Change password</v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </transition>
    </v-row>
  </v-container>
</template>

<script>
import trim from 'lodash/trim'
import Logo from '@/assets/img/logo.svg'

export default {
  name: 'ForgotPassword',
  components: {
    Logo
  },
  data () {
    return {
      repeatPasswordRules: [
        v => !!v || this.$gettext('Repeat the password please'),
        v => (v && v === this.newPassword) || this.$gettext('Passwords must match')
      ],
      requestValid: false,
      answerValid: false,
      email: this.$root.loggedUser ? this.$root.auth.loggedUser.username : null,
      code: null,
      serverError: null,
      newPassword: null,
      repeatNewPassword: null,
      showForgotPasswordAnswer: false
    }
  },
  methods: {
    async sendRequest () {
      if (this.$refs.requestForm.validate()) {
        await this.$root.auth.sendForgotPasswordRequest(trim(this.email).toLowerCase())
        this.showForgotPasswordAnswer = true
        this.serverError = null
      }
    },
    async sendAnswer () {
      if (this.$refs.answerForm.validate()) {
        try {
          await this.$root.auth.answerForgotPasswordCode(trim(this.email).toLowerCase(), this.code, this.newPassword)
        } catch (e) {
          this.serverError = e.message
          return
        }
        this.$router.replace({ name: 'Onboarding', params: { precompiledEmail: this.email.toLowerCase(), precompiledPassword: this.newPassword } })
      }
    }
  }
}
</script>
